import { useQuery } from '@tanstack/react-query';
import { BotAPIClient } from '@/api/client';
import { useRef } from 'react';
export function useWhales(version, enabled = true) {
    const clientRef = useRef(null);
    if (!clientRef.current || clientRef.current.getVersion() !== version) {
        clientRef.current = new BotAPIClient(version);
    }
    return useQuery({
        queryKey: ['whales', version],
        queryFn: async () => {
            const response = await clientRef.current.getWhales();
            if ('error' in response) {
                throw new Error(response.error);
            }
            return response;
        },
        enabled,
        staleTime: 60000,
        refetchInterval: 60000,
        placeholderData: (prev) => prev,
    });
}
//# sourceMappingURL=useWhales.js.map